import GetMembershipStatusRequestModelBase from '../_generated/modelBases/get-membership-status-request-model-base';

export default class GetMembershipStatusRequestModel extends GetMembershipStatusRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
